import type { IconData } from '@stacksjs/iconify-core'

export const phoneActionsRemove2: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.48 19.81v-1.53h-1.53v3.05h-1.52v1.52H25.9v1.53h1.53v1.52h1.52v3.05h1.53v-1.53H32v-7.61zm-4.58 7.61h-1.52V25.9h-1.52v1.52h-1.53v1.53h-3.05v1.52h1.53V32h7.62v-1.53h1.52v-1.52H25.9zm-4.57-7.61h1.53v1.52h1.52v-1.52h1.52v-1.53h3.05v-1.52h-1.52v-1.53h-7.62v1.53h-1.53v1.52h3.05zm-1.52 6.09v-1.52h1.52v-1.53h-1.52v-1.52h-1.53v-3.05h-1.52v1.53h-1.52v7.61h1.52v1.53h1.52V25.9zm-6.1-15.24h3.05v1.53h-3.05Z\"/><path fill=\"currentColor\" d=\"M16.76 32v-1.53h-1.52v-1.52H1.52V3.04h4.57v1.53h9.15V3.04h4.57v10.67h1.52V1.52h-1.52V0H1.52v1.52H0v28.95h1.52V32ZM10.67 1.52h3.04v1.52h-3.04Zm-3.05 0h1.52v1.52H7.62Z\"/><path fill=\"currentColor\" d=\"M6.09 16.76h9.15v1.52H6.09Zm-1.52-6.1h3.05v1.53H4.57Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default phoneActionsRemove2
